import React, {MouseEventHandler} from 'react';
import {Dropdown} from 'react-bootstrap';
import {SvgIcon} from '../../icons/svgIcon';
import {Icons} from '../../icons/icons';

export type ChatInputDropdownProps = {
    handleReset: () => void;
    handleHelp: () => MouseEventHandler;
    resetLabel: string;
    helpLabel: string;
};

export const ChatInputSettings = ({
    handleReset,
    handleHelp,
    resetLabel,
    helpLabel,
}: ChatInputDropdownProps): React.JSX.Element => (
    <Dropdown id="chat-input-dropdown" drop="up" title="chat-input-dropdown" className="chat-input-dropdown">
        <Dropdown.Toggle id="chat-input-toggle">
            <SvgIcon icon={Icons.MORE} id="icon-menu" />
        </Dropdown.Toggle>
        <Dropdown.Menu className="chat-input-menu">
            <Dropdown.Item eventKey="1" onClick={handleReset}>
                {resetLabel}
            </Dropdown.Item>
            <Dropdown.Item eventKey="2" onClick={handleHelp()}>
                {helpLabel}
            </Dropdown.Item>
        </Dropdown.Menu>
    </Dropdown>
);
